/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
export default {
    SET_TRANSFER_SELECTED(state, payload) {
        switch (payload.action) {
            case 'add':
                state.transfersSelected.push(payload.item);
                break;
            case 'remove':
                const indexItem = state.transfersSelected.indexOf(payload.item);
                state.transfersSelected.splice(indexItem, 1);
                break;
            default:
                break;
        }
    },
    SET_MARGIN(state, value) {
        state.margin = value;
    },
    REMOVE_TRANSFER(state, item) {
        const index = state.transfersSelected.indexOf(item);
        state.transfersSelected.splice(index, 1);
    },
    REMOVE_OPERATION(state, item) {
        const index = state.operationsSelected.indexOf(item);
        state.operationsSelected.splice(index, 1);
    },
    REMOVE_TRANSFERS_SELECTED(state) {
        state.transfersSelected = [];
    },
    SET_OPERATION_SELECTED(state, payload) {
        switch (payload.action) {
            case 'add':
                state.operationsSelected.push(payload.item);
                break;
            case 'remove':
                const indexItem = state.operationsSelected.indexOf(payload.item);
                state.operationsSelected.splice(indexItem, 1);
                break;
            default:
                break;
        }
    },
    REMOVE_OPERATIONS_SELECTED(state) {
        state.operationsSelected = [];
    },
    SET_GROUPED_SELECTED(state, value) {
        state.groupedSelected = value;
    },
    SET_UUID_GROUPED_SELECTED(state, value) {
        state.uuidGroupedSelected = value;
    },
    SET_SUGGESTIONS(state, value) {
        state.suggestions = value;
    },
    SET_DISABLE_GROUPS(state, value) {
        state.disableGroups = value;
    },
    SET_COMMENT(state, value) {
        state.comment = value;
    },
    SET_SEARCHBY(state, value) {
        state.searchBy = value;
    },
    SET_DISABLEALL(state, value) {
        state.disableAll = value;
    }
};
